
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllTaskSubmissions,
  updateTaskStatus,
  bulkUpdateTaskStatus,
} from "../redux/actions/taskActions";
import { fetchDistricts, fetchMunicipalities } from "../redux/actions/locationActions";
import { fetchDesignations } from "../redux/actions/designationActions";

import { FiSearch, FiDownload } from "react-icons/fi";
import Papa from "papaparse";
import theme from "../components/shared/theme";
import {
  dropdownStyle,
  thStyle,
  tdStyle,
  paginationButtonStyle,
} from "../components/shared/themeStyles";

// const formatIndianDate = (dateStr) => {
//   if (!dateStr) return "-";
//   const date = new Date(dateStr);
//   const day = String(date.getDate()).padStart(2, "0");
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const year = date.getFullYear();
//   return `${day}-${month}-${year}`;
// };
const formatIndianDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);

  // Convert to IST
  const offset = date.getTimezoneOffset() * 60000;
  const istDate = new Date(date.getTime() - offset);

  const day = String(istDate.getDate()).padStart(2, "0");
  const month = String(istDate.getMonth() + 1).padStart(2, "0");
  const year = istDate.getFullYear();

  let hours = istDate.getHours();
  const minutes = String(istDate.getMinutes()).padStart(2, "0");
  const seconds = String(istDate.getSeconds()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert 0 -> 12 for midnight
  hours = String(hours).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds} ${ampm}`;
};


const Task = () => {
  const dispatch = useDispatch();

  const {
    items: taskSubmissions = [],
    pagination = {},
    loading,
    error,
  } = useSelector((state) => state.task.taskSubmissions || {});

  const { districts = [], municipalities = [] } = useSelector((state) => state.location || {});
const { designations = [] } = useSelector((state) => state.designation || {});

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedMunicipality, setSelectedMunicipality] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedTasks, setSelectedTasks] = useState([]);
const [selectedDesignation, setSelectedDesignation] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("pending");


  const fetchTasks = (page = currentPage) => {
    dispatch(
      fetchAllTaskSubmissions({
        page,
        limit: itemsPerPage,
        district: selectedDistrict,
        municipality: selectedMunicipality,
        fromDate,
        toDate,
        search: searchTerm,
         designation: selectedDesignation, 
         status: selectedStatus,
      })
    );
  };

  useEffect(() => {
    dispatch(fetchDistricts());
    dispatch(fetchMunicipalities());
     dispatch(fetchDesignations()); 
  }, [dispatch]);

  useEffect(() => {
    fetchTasks();
  }, [
    currentPage,
    selectedDistrict,
    selectedMunicipality,
    fromDate,
    toDate,
    searchTerm,
    selectedDesignation,
     selectedStatus,
  ]);

  const selectedDistrictObj = districts.find(d => d.name === selectedDistrict);
const selectedDistrictId = selectedDistrictObj?.id;

const filteredMunicipalities = selectedDistrictId
  ? municipalities.filter(m => m.district_id === selectedDistrictId)
  : municipalities;

useEffect(() => {
  setSelectedMunicipality("");
}, [selectedDistrict]);
const BASE_URL = process.env.REACT_APP_API_BASE_URL;


  // const handleExportCSV = () => {
  //   const exportData = taskSubmissions.map((task) => ({
  //     District: task.user_district || "-",
  //     Municipality: task.user_municipality || "-",
  //     TaskTitle: task.task_title || "-",
  //     TaskName: task.task_name || "-",
  //     Name: task.user_name || "-",
  //     designation: task.designation || "-",
  //     Phone: task.user_phone || "-",
  //     Date: formatIndianDate(task.date),
  //     Time: task.time || "-",
  //     TaskPeriod: `${formatIndianDate(task.createTaskDate)} - ${formatIndianDate(task.endTaskDate)}`,
  //     Status: task.status || "-",
  //     PhotoURL: task.photo || "-",
  //   }));

  //   const csv = Papa.unparse(exportData);
  //   const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  //   const url = URL.createObjectURL(blob);
  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.setAttribute("download", "Task_Report.csv");
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

const handleExportCSV = async () => {
  try {
    const token = localStorage.getItem("token");

    const queryParams = new URLSearchParams({
      page: 1,
      limit: 10000, // large number to get all matching data
      district: selectedDistrict,
      municipality: selectedMunicipality,
      fromDate,
      toDate,
      search: searchTerm,
      designation: selectedDesignation,
      status: selectedStatus,
    }).toString();

    const response = await fetch(
      `${BASE_URL}/v1/api/admin/getAllTaskSubmitByAdmin?${queryParams}`,
      {
        headers: {
          Authorization: token,
        },
      }
    );

    const data = await response.json();
    const filteredTasks = data?.data || [];

    const csvRows = [
      [
        "District",
        "Municipality",
        "Task Title",
        "Task Name",
        "Name",
        "Phone",
        "Designation",
        "Date",
        "Time",
        "Task Period",
        "Status",
        "Photo URL",
        "Endorsed By",
        "Endorsed time"
      ],
    ];

    filteredTasks.forEach((task) => {
      const formatDate = (dateStr) => {
        if (!dateStr) return "-";
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      };

      csvRows.push([
        task.user_district || "-",
        task.user_municipality || "-",
        task.task_title || "-",
        task.task_name || "-",
        task.user_name || "-",
        task.user_phone || "-",
        task.designation || "-",
        formatDate(task.date),
        task.time || "-",
        `${formatDate(task.createTaskDate)} - ${formatDate(task.endTaskDate)}`,
        task.status || "-",
        task.photo || "-",
          task.admin_username || "-",
        task.status_updated_at || "-",
      ]);
    });

    const csv = Papa.unparse(csvRows, { skipEmptyLines: true });
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "Filtered_Task_Submissions.csv");
    link.click();
  } catch (err) {
    console.error("Failed to download CSV:", err);
    alert("Failed to download CSV. Please try again.");
  }
};

 

  const toggleSelectAll = () => {
    const allIds = taskSubmissions.map((item) => item.id);
    const allSelected = allIds.every((id) => selectedTasks.includes(id));
    if (allSelected) {
      setSelectedTasks((prev) => prev.filter((id) => !allIds.includes(id)));
    } else {
      setSelectedTasks((prev) => [...new Set([...prev, ...allIds])]);
    }
  };

  const toggleSelectOne = (id) => {
    if (selectedTasks.includes(id)) {
      setSelectedTasks((prev) => prev.filter((itemId) => itemId !== id));
    } else {
      setSelectedTasks((prev) => [...prev, id]);
    }
  };

  const handleBulkUpdate = (status) => {
    dispatch(bulkUpdateTaskStatus(selectedTasks, status)).then(() => {
      setSelectedTasks([]);
      fetchTasks(currentPage); // ✅ Maintain same page
    });
  };

  const handleStatusUpdate = (taskId, status) => {
    dispatch(updateTaskStatus(taskId, status)).then(() => {
      fetchTasks(currentPage); // ✅ Maintain same page
    });
  };

  const totalPages = Math.ceil((pagination?.total || 0) / (pagination?.limit || itemsPerPage));

  return (
    <div style={{ backgroundColor: theme.colors.background, padding: theme.spacing.md }}>
      <h1 style={{ fontSize: theme.font.size["2xl"], fontWeight: theme.font.weight.bold }} className="mb-4">
        Task Submissions
      </h1>

      {/* Filters */}
      <div className="flex flex-wrap gap-3 items-center bg-white p-4 rounded-lg shadow mb-6">
        <select value={selectedDistrict} onChange={(e) => { setSelectedDistrict(e.target.value); setCurrentPage(1); }} style={dropdownStyle}>
          <option value="">All Districts</option>
          {districts?.map((d) => <option key={d.id || d.name} value={d.name}>{d.name}</option>)}
        </select>
{/* 
        <select value={selectedMunicipality} onChange={(e) => { setSelectedMunicipality(e.target.value); setCurrentPage(1); }} style={dropdownStyle}>
          <option value="">All Municipalities</option>
          {municipalities?.map((m) => <option key={m.id || m.name} value={m.name}>{m.name}</option>)}
        </select> */}
        <select
  value={selectedMunicipality}
  onChange={(e) => {
    setSelectedMunicipality(e.target.value);
    setCurrentPage(1);
  }}
  style={dropdownStyle}
>
  <option value="">All Municipalities</option>
  {filteredMunicipalities.map((m) => (
    <option key={m.id} value={m.name}>
      {m.name}
    </option>
  ))}
</select>

        <select
  value={selectedDesignation}
  onChange={(e) => {
    setSelectedDesignation(e.target.value);
    setCurrentPage(1);
  }}
  style={dropdownStyle}
>
  <option value="">All Designations</option>
  {designations.map((d, i) => (
    <option key={i} value={d}>
      {d}
    </option>
  ))}
</select>
<select value={selectedStatus} onChange={(e) => { setSelectedStatus(e.target.value); setCurrentPage(1); }} style={dropdownStyle}>
          <option value="">All Status</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
          <option value="ongoing">Ongoing</option>
          <option value="complete">Complete</option>
        </select>



        <div className="relative w-full sm:w-[250px]">
          <FiSearch className="absolute left-3 top-3 text-gray-500" />
          <input
            type="text"
            placeholder="Search name, phone, title"
            value={searchTerm}
            onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
            style={{ ...dropdownStyle, paddingLeft: theme.spacing.lg }}
          />
        </div>

        <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={dropdownStyle} />
        <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={dropdownStyle} />

        <button onClick={() => { setFromDate(""); setToDate(""); setCurrentPage(1); }} style={{ backgroundColor: theme.colors.primary, color: "#fff", padding: theme.spacing.sm, borderRadius: theme.radius.md }}>
          Reset Date
        </button>

        <button onClick={handleExportCSV} style={{ backgroundColor: theme.colors.secondary, color: "#fff", padding: theme.spacing.sm, borderRadius: theme.radius.md, display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <FiDownload /> Export CSV
        </button>

        <button onClick={() => handleBulkUpdate("approved")} disabled={selectedTasks.length === 0} style={{ backgroundColor: theme.colors.success, color: "#fff", padding: theme.spacing.sm, borderRadius: theme.radius.md }}>
          Bulk Approve
        </button>

        <button onClick={() => handleBulkUpdate("rejected")} disabled={selectedTasks.length === 0} style={{ backgroundColor: theme.colors.danger, color: "#fff", padding: theme.spacing.sm, borderRadius: theme.radius.md }}>
          Bulk Reject
        </button>
      </div>

      {/* Table */}
      {loading ? (
        <p>Loading tasks...</p>
      ) : error ? (
        <p className="text-red-600">Error: {error}</p>
      ) : (
        <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
          <table className="min-w-[1100px] w-full text-sm text-left">
            <thead style={{ backgroundColor: theme.colors.grayDark, color: "white" }}>
              <tr>
                <th style={thStyle}>
                  <input type="checkbox" checked={taskSubmissions.every((item) => selectedTasks.includes(item.id))} onChange={toggleSelectAll} />
                </th>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Task Title</th>
                <th style={thStyle}>Task Name</th>
                <th style={thStyle}>Name</th>
                <th style={thStyle}>Phone</th>
                <th style={thStyle}>Designation</th>
                <th style={thStyle}>District</th>
                <th style={thStyle}>Municipality</th>
                <th style={thStyle}>Photo</th>
                <th style={thStyle}>Date</th>
                <th style={thStyle}>Time</th>
                <th style={thStyle}>Task Period</th>
                <th style={thStyle}>Status</th>
                 <th style={thStyle}>Endorsed By</th>
                  <th style={thStyle}>Endorsed time</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {taskSubmissions.map((task, index) => (
                <tr key={task.id || index} className="hover:bg-gray-50">
                  <td style={tdStyle}>
                    <input type="checkbox" checked={selectedTasks.includes(task.id)} onChange={() => toggleSelectOne(task.id)} />
                  </td>
                  <td style={tdStyle}>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td style={tdStyle}>{task.task_title || "-"}</td>
                  <td style={tdStyle}>{task.task_name || "-"}</td>
                  <td style={tdStyle}>{task.user_name || "-"}</td>
                  <td style={tdStyle}>{task.user_phone || "-"}</td>
                  <td style={tdStyle}>{task.designation || "-"}</td>
                  <td style={tdStyle}>{task.user_district || "-"}</td>
                  <td style={tdStyle}>{task.user_municipality || "-"}</td>
                  <td style={tdStyle}>
                    {task.photo ? (
                      <button onClick={() => window.open(task.photo, "_blank")} style={{ color: theme.colors.primary, textDecoration: "underline", background: "none", border: "none", cursor: "pointer" }}>
                        View Photo
                      </button>
                    ) : "-"}
                  </td>
                  <td style={tdStyle}>{formatIndianDate(task.date)}</td>
                  <td style={tdStyle}>{task.time || "-"}</td>
                  <td style={tdStyle}>{`${formatIndianDate(task.createTaskDate)} - ${formatIndianDate(task.endTaskDate)}`}</td>
                  <td style={tdStyle}>
                    {task.status === "pending" ? (
                      <div className="flex gap-2">
                        <button onClick={() => handleStatusUpdate(task.id, "approved")} className="px-2 py-1 bg-green-500 text-white rounded text-xs">Approve</button>
                        <button onClick={() => handleStatusUpdate(task.id, "rejected")} className="px-2 py-1 bg-red-500 text-white rounded text-xs">Reject</button>
                      </div>
                    ) : (
                      <span className="capitalize">{task.status}</span>
                    )}
                  </td>
                   <td style={tdStyle}>{task.admin_username || "-"}</td>
                   <td style={tdStyle}>{formatIndianDate(task.status_updated_at) || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="flex justify-between items-center p-4 border-t">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              style={paginationButtonStyle}
            >
              Previous
            </button>
            <p className="text-sm">Page {currentPage} of {totalPages || 1}</p>
            <button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage >= totalPages}
              style={paginationButtonStyle}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Task;



